/**
 * URL helper utilities for external service links.
 */

export const NYC_PROPERTY_PORTAL_BASE = 'https://propertyinformationportal.nyc.gov/parcels/parcel/';

export function nycPropertyPortalUrl(bbl) {
  return NYC_PROPERTY_PORTAL_BASE + encodeURIComponent(String(bbl).trim());
}

// 1940s.nyc tax photo viewer. Photo IDs are deterministic from BBL:
// nynyma_rec0040_{borough}_{block:5}_{lot:4}
export function nyc1940sPhotoUrl(bbl) {
  const s = String(bbl || '').trim();
  if (!/^\d{10}$/.test(s)) return null;
  const borough = s.slice(0, 1);
  const block = s.slice(1, 6);
  const lot = s.slice(6, 10);
  return `https://1940s.nyc/map/photo/nynyma_rec0040_${borough}_${block}_${lot}`;
}
